import React, { useRef, useEffect, Fragment } from 'react'
import { Switch, Route, NavLink, Link } from 'react-router-dom'
import { YMInitializer } from 'react-yandex-metrika'
import { translate } from 'react-i18next'

import Intro from './Pages/Intro'
import Service from './Pages/Service'
import OurWorks from './Pages/OurWorks'
// import Estimate from './Pages/Estimate'
import Contacts from './Pages/Contacts'
import Cookie from './Pages/Cookie'

import DS from './Pages/Projects/DS'
import DM from './Pages/Projects/DM'
import MU from './Pages/Projects/MU'
import Tommy from './Pages/Projects/Tommy'
import PP from './Pages/Projects/PP'

import './hamburgers.css'
import './navbar.css'
import './gdpr.css'

const App = ({ t, i18n }) => {

    const app = useRef(null)
    const nav = useRef(null)
    const gdpr = useRef(null)
    const menuButton = useRef(null)
    const sidebar = useRef(null)

    const getGDPRCookie = () => {
        let matches = document.cookie.match(new RegExp(
            // eslint-disable-next-line
            "(?:^|; )" + "gdpr".replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ))
        return matches ? decodeURIComponent(matches[1]) : null
    }

    useEffect(() => {
        if(getGDPRCookie() === null)
           gdpr.current.classList.remove('app__gdpr-dismiss')
        else
            gdpr.current.classList.add('app__gdpr-dismiss')

        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name).then(r => {})
            })
        })
    }, [])

    const onMenuClick = () => {
        menuButton.current.classList.toggle('is-active')
        app.current.classList.toggle('app--left-offset')
        sidebar.current.classList.toggle('app__sidebar-active')
    }

    const onDismissClick = () => {
        gdpr.current.classList.add('app__gdpr-dismiss')
        document.cookie = "gdpr=dismissed"
    }

    return (
        <Fragment>
            <YMInitializer accounts={[ 45012259 ]} options={{ webvisor: true, clickmap: true, trackLinks: true, accurateTrackBounce: true }} version="2" />
            <div className="app" ref={ app }>

                <nav className="app__nav" ref={ nav }>
                    <div className="app__nav--logo">
                        <Link to="/">clockwork</Link>
                    </div>
                    <div className="app__nav--right">
                        <div className="app__nav--links">
                            <NavLink to="/service" activeClassName="active">{ t('Service') }</NavLink>
                            <NavLink to="/our-works" activeClassName="active">{ t('Our Works') }</NavLink>
                            {/*<NavLink to="/estimate" activeClassName="active">{ t('Estimate') }</NavLink>*/}
                            <NavLink to="/contacts" activeClassName="active">{ t('Contacts') }</NavLink>
                        </div>
                        <div className="app__nav--langs">
                <span
                    className={ i18n.language === 'ru' ? 'bold' : 'normal' }
                    onClick={ () => i18n.changeLanguage('ru') }>
                  Ru
                </span>&nbsp;/&nbsp;
                            <span
                                className={ i18n.language === 'en' ? 'bold' : 'normal' }
                                onClick={ () => i18n.changeLanguage('en') }>
                  En
                </span>
                        </div>
                    </div>
                    <div className="app__nav--right-mobile">
                        <button
                            className="hamburger hamburger--collapse"
                            type="button"
                            ref={ menuButton }
                            onClick={ onMenuClick }>
                <span className="hamburger-box">
                  <span className="hamburger-inner" />
                </span>
                        </button>
                    </div>
                </nav>

                <Switch>
                    <Route exact path='/' component={ Intro } />
                    <Route path='/service' component={ Service } />
                    <Route exact path='/our-works' component={ OurWorks } />
                    <Route path='/our-works/direct-scouting-center' component={ DS } />
                    <Route path='/our-works/medunion' component={ MU } />
                    <Route path='/our-works/tommy' component={ Tommy } />
                    <Route path='/our-works/pluspatch' component={ PP } />
                    <Route path='/our-works/domautomatika' component={ DM } />
                    {/*<Route path='/estimate' component={ Estimate } />*/}
                    <Route path='/contacts' component={ Contacts } />
                    <Route path='/how-we-use-cookie' component={ Cookie } />
                </Switch>

            </div>

            <aside className="app__sidebar" ref={ sidebar }>
                <div className="app__nav--links-sidebar">
                    <NavLink onClick={ onMenuClick } to="/service" activeClassName="active">{ t('Service') }</NavLink>
                    <NavLink onClick={ onMenuClick } to="/our-works" activeClassName="active">{ t('Our Works') }</NavLink>
                    {/*<NavLink onClick={ onMenuClick } to="/estimate" activeClassName="active">{ t('Estimate') }</NavLink>*/}
                    <NavLink onClick={ onMenuClick } to="/contacts" activeClassName="active">{ t('Contacts') }</NavLink>
                    <div className="app__nav--langs-sidebar">
              <span
                  className={ i18n.language === 'ru' ? 'bold' : 'normal' }
                  onClick={ () => i18n.changeLanguage('ru') }>
                Ru
              </span>&nbsp;/&nbsp;
                        <span
                            className={ i18n.language === 'en' ? 'bold' : 'normal' }
                            onClick={ () => i18n.changeLanguage('en') }>
                En
              </span>
                    </div>
                </div>
            </aside>

            <div className="app__gdpr" ref={ gdpr }>
                <div className="app__gdpr--text">
                    <span>{ t('cookie-text') }</span>
                    <span> </span>
                    <Link to="/how-we-use-cookie" className="app__link-gdpr">{ t('cookie-link') }</Link>
                </div>
                <div className="app__gdpr--dismiss">
                    <button
                        type="button"
                        aria-label="Close"
                        onClick={ onDismissClick }
                        className="app__gdpr--dismiss-close" />
                </div>
            </div>

        </Fragment>
    )
}

export default translate('translations')(App)



// WEBPACK FOOTER //
// ./src/App.js